import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";

function getTags(row: FulfillmentGroupData): string[] {
  return Array.from(new Set(row.orders.flatMap((order) => order.tags)));
}

export const ShopifyOrderTagsCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Order tags",
    cell: (row) => {
      const renderedTags = getTags(row);
      return renderedTags.join(",");
    },
  };
